import { Reveal, SectionHead } from "./Reveal";
import { useLang } from "../i18n";

export const Testimonials = () => {
  const { t } = useLang();
  return (
    <section id="temoignages" data-testid="testimonials-section" className="border-t border-oris-green/10 bg-white py-24 lg:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead overline={t.testimonials.overline} title={t.testimonials.title} testId="testimonials-title" />

        <div className="grid gap-6 lg:grid-cols-3">
          {t.testimonials.items.map((item, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <blockquote
                data-testid={`testimonial-${i}`}
                className="flex h-full flex-col justify-between border border-oris-green/12 bg-oris-cream p-8 lg:p-10"
              >
                <div>
                  <span className="font-serif text-6xl leading-none text-oris-gold" aria-hidden="true">“</span>
                  <p className="mt-2 font-serif text-xl italic leading-relaxed text-oris-ink lg:text-[1.35rem]">
                    {item.quote}
                  </p>
                </div>
                <footer className="mt-8 border-t border-oris-green/10 pt-5">
                  <div className="text-sm font-bold uppercase tracking-[0.14em] text-oris-green">{item.name}</div>
                  <div className="mt-1 text-xs text-oris-moss">{item.role}</div>
                </footer>
              </blockquote>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-20">
            <p className="mb-8 text-center text-[0.7rem] font-bold uppercase tracking-[0.3em] text-oris-moss">
              {t.testimonials.partnersTitle}
            </p>
            <div data-testid="partners-strip" className="flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
              {t.testimonials.partners.map((p) => (
                <span
                  key={p}
                  className="font-serif text-lg font-semibold tracking-[0.22em] text-oris-green/40 transition-colors duration-500 hover:text-oris-green"
                >
                  {p}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
